import Vue from 'vue'
import ClickOutside from './ClickOutside'

Vue.directive('ClickOutside', ClickOutside)



// WEBPACK FOOTER //
// ./src/directives/index.js